const VALUE_TYPES = {
    TEXT: "text",
    TEXTAREA: "textarea",
    PASSWORD: "password",
    NUMBER: "number",
    DECIAML: "deciaml",
    DATE: "date",
    SWITCH: "switch",
    SELECT: "select",
    MULTISELECT: "multiselect",
    EDIT: "edit",
    DATEPICKER: "datepicker",
    RADIO: "radio",
    AUTOCOMPLETE: "autocomplete",
    ACTIONS: "actions"
}

export default VALUE_TYPES;